export const FAQ_COSTANTS = {
    BIANCO: 1,
    VERDE: 2,
    AZZURRO: 3,
    ARANCIONE: 4,
    ROSSO: 5,
    VISITA: 6,
    OSSERVAZIONE: 7,
    ATTESA: 8,
    DIMESSO: 9,
    PAGAMENTO: 10
}

export const GENERAL_STATUS_COSTANTS = {
    VISITA: 'VISITA',
    OSSERVAZIONE: 'OSSERVAZIONE',
    ATTESA: 'ATTESA',
    DIMESSO: 'DIMESSO',
    NOT_YET_AVAILABLE: 'NOT_YET_AVAILABLE', //in elaborazione
    NOT_AVAILABLE: 'NOT_AVAILABLE'
}

export const EXAMS_STATUS_ID = {
    ELABORAZIONE: -1,
    RICHIESTO: 0,
    COMPLETATO: 1,
    IN_CORSO: 2
}